/* eslint-disable no-param-reassign */
import produce from 'immer';
import { REQUEST_MEALS, GET_MEALS } from 'src/actions/mealActions';

const initialState = {
  items: [],
  isFetching: false,
  message: ''
};

const mealReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_MEALS: {
      return produce(state, (draft) => {
        draft.isFetching = true;
      });
    }

    case GET_MEALS: {
      const { meals, message } = action.payload;

      return produce(state, (draft) => {
        draft.items = meals;
        draft.isFetching = false;
        draft.message = message;
      });
    }

    default: {
      return state;
    }
  }
};

export default mealReducer;
